

















































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";

export default Vue.extend({
  components: {
    Modal,
  },
  props: ["modalData"],
  setup(_, { emit }) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "50rem",
      height: "auto",
      withTopRightCloseBtn: true,
    };
    const go_to_admins = () => {
      emit("submit", "admins");
    };

    return {
      config,
      go_to_admins,
    };
  },
});
